export { FlatFacetShell } from './FlatFacetShell';
export type { FlatFacetShellProps } from './FlatFacetShell.types';
